import { useEffect, useState } from 'react';
import log from 'chameleon/ui-stack/utilities/log';
import fetchFlags from 'legacy-src/utility/featureFlag/fetchFlags';
import { flagListWithConfig } from 'legacy-src/reducers/featureFlag';

const useFetchFlagsWithConfig = ({
  initId,
  setFeatureFlagAction,
  attributes = {},
}) => {
  const [fetchedFlags, setFetchedFlags] = useState(null);
  const flagsByKeys = Object.keys(flagListWithConfig);
  const callback = (treatments) => {
    const {
      payload: { flags },
    } = setFeatureFlagAction({
      ...treatments,
    });
    setFetchedFlags(flags);
  };

  useEffect(() => {
    fetchFlags(
      flagsByKeys,
      initId,
      attributes,
      {
        singleFlagSplitFunction: 'getTreatmentWithConfig',
        multipleFlagSplitFunction: 'getTreatmentsWithConfig',
      },
      callback,
    )
      .then(callback)
      .catch((error) => {
        log('error', error);
      });
  }, [initId]);
  return [fetchedFlags];
};

export default useFetchFlagsWithConfig;
